import { Pressable, FlatList } from "react-native";
import { FindifyTopBarOverlay } from "../genericPages/components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { BasePage } from "../genericPages/helpers/BasePage";
import { useTranslation } from "react-i18next";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../genericPages/components/PlaceText";
import { BaseFindifyList } from "../genericPages/components/FindifyList";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import { PlaceListInitialUseEffect, PlaceListOnSelectedCategoryChangeEffect, loadContentsPageFromApi } from "@/layouts/genericPages/helpers/PlaceListHelper";
import { getContentIdForModule, getFeaturedImageUrl, makeContentDate } from "@/layouts/genericPages/helpers/DetailsHelpers";
import { DefaultShadow } from "../genericPages/helpers/DefaultShadows";
import { EventsListItemLine } from "./PlaceTab";


export const PlaceContentListTab = ({ navigation, ...props }: any) => {
    const [contents, setContents] = useState([]);
    const { t } = useTranslation();
    const [module, setModule] = useState('');
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const findifyDataContext = useContext(FindifyDataContext);
    const [loaded, setLoaded] = useState(false);
    const [availableModuleCategories, setAvailableModuleCategories] = useState<any[]>([]);
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);

    useEffect(() => {
        PlaceListInitialUseEffect({
            props,
            setContents,
            setLoaded,
            setModule,
            setSelectedCategories,
            findifyDataContext,
            setAvailableModuleCategories,
            contents,
        });
    }, [])


    useEffect(() => {
        PlaceListOnSelectedCategoryChangeEffect({
            loaded,
            selectedCategories,
            setContents,
            module,
            findifyDataContext,
            setActionsList,
            availableModuleCategories,
            t,
        });
    }, [selectedCategories])


    const header = <FindifySimpleHeader navigation={navigation}
        // module if no category filter or multiple category filter, single cat filter shows cat title
        title={
            selectedCategories.length === 1 ?
                getTranslatedString(
                    availableModuleCategories.find((cat: any) => cat.category_id === selectedCategories[0])?.name, findifyDataContext) :
                t('modules.content_types.' + module)
        }
        isEventLayout
        actions={actionsList}
    // image={findifyDataContext?.workspace.app_settings?.app_banner_url} 
    />;

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <BaseFindifyList
            items={contents.map((content: any) => {
                const contentId = getContentIdForModule(content, module);
                return {
                    ...content,
                    id: contentId,
                    image: getFeaturedImageUrl(content),
                    // title: makeContentTitle(content, module, findifyDataContext),
                    // resume: getTranslatedString(content.resume, findifyDataContext),
                    date: makeContentDate(content, module),
                    onPress: () => {
                        navigation.push('PlaceContentDetails', {
                            module: module,
                            content_id: contentId,
                            page_slug: content.page_slug
                        });
                    } 
                };
            })}
            header={<>
                {header}
                <FlatList
                    key={'listcategories'}
                    data={availableModuleCategories}
                    horizontal
                    renderItem={({ item, index }) => {
                        const catSelected = selectedCategories.includes(item.category_id);
                        return <Pressable
                            onPress={() => {
                                if (catSelected) {
                                    setSelectedCategories(selectedCategories.filter(cat => cat !== item.category_id));
                                } else {
                                    setSelectedCategories([...selectedCategories, item.category_id]);
                                }
                            }}
                            style={{
                                ...DefaultShadow,
                                borderRadius: 100,
                                backgroundColor: catSelected ?
                                    PlaceColors(findifyDataContext).text.get()
                                    : PlaceColors(findifyDataContext).background.get(),
                                padding: 10,
                                marginVertical: 4,
                                marginLeft: 6,
                            }}
                        >
                            <PlaceText
                                style={{
                                    color: catSelected ?
                                        PlaceColors(findifyDataContext).background.get() :
                                        PlaceColors(findifyDataContext).text.get(),
                                }}
                            >
                                {getTranslatedString(item.name, findifyDataContext)}
                            </PlaceText>
                        </Pressable>;
                    }} />
            </>}
            onEndReached={() => {
                if (loaded) {
                    loadContentsPageFromApi(selectedCategories, contents, module, findifyDataContext, setContents);
                }
            }}
            renderLine={(item, index) => {
                return EventsListItemLine(1, item, index, findifyDataContext, contents.length);
            }}
            enableGrid={false}
        />
    </BasePage >;
};
